<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="1rem">
  <app-customer-search [control]="formGroup.get('customer')"></app-customer-search>
  <app-construction-site-search [control]="formGroup.get('constructionSite')"></app-construction-site-search>
  <mat-form-field appearance="outline">
    <mat-label>{{ 'tourDetails.tourKind' | translate }}</mat-label>
    <mat-select placeholder="{{ 'tourDetails.tourKind' | translate }}" [formControl]="formGroup.get('tourType')">
      <mat-option [value]="tourClass.Delivery">{{ 'tourDetails.tourKinds.delivery' | translate }}</mat-option>
      <mat-option [value]="tourClass.Maintenance">{{ 'tourDetails.tourKinds.maintenance' | translate }}</mat-option>
      <mat-option [value]="tourClass.Service">{{ 'tourDetails.tourKinds.service' | translate }}</mat-option>
      <mat-option [value]="tourClass.Return">{{ 'tourDetails.tourKinds.return' | translate }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'core.date' | translate }}</mat-label>
    <input matInput
      [matDatepicker]="picker"
      [formControl]="formGroup.get('appointment.date')"
      [readonly]="!tour.allowPostpone"
      [disabled]="!tour.allowPostpone"
      (dateChange)="onTourDateChanged($event)"
      >
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <div fxLayout="row">
    <mat-button-toggle-group disabled="true">
      @for (tourState of tourStates.slice(0, -1); track tourState) {
        <mat-button-toggle
          [value]="tourState.name"
          [class.done]="(tour.state | numericState) > (tourState.name | numericState)"
          [class.pending]="(tour.state | numericState) == (tourState.name | numericState)"
          >
          <mat-icon [svgIcon]="tourState.svgIcon">{{tourState.matIcon}}</mat-icon>
        </mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
</div>
